import type { Effect, Reducer, Subscription } from '@umijs/max';
import type { SingleBrandType } from './data';
import { addBrand, editBrand, getBrandPage, removeBrand } from './service';

export type BrandState = {
  code: number;
  type: string;
  message: string;
  total: number;
  current: number;
  pageSize: number;
  items: SingleBrandType[];
};

type BrandModelType = {
  namespace: string;
  state: BrandState;
  reducers: {
    BrandReducer: Reducer<BrandState>;
  };
  effects: {
    fetchBrandPageEffect: Effect;
    refreshDataEffect: Effect;
    addBrandEffect: Effect;
    editBrandEffect: Effect;
    removeBrandEffect: Effect;
  };
  subscriptions: {
    setup: Subscription;
  };
};

// 通用操作处理函数
const createEffect = (serviceCall: any) =>
  function* (
    { payload: action, callback }: any,
    { call, put }: any,
  ): Generator<any, void, any> {
    try {
      const res: any = yield call(
        serviceCall,
        action.values || { id: action.id },
      );

      if (res && res.code === 0) {
        yield put({
          type: 'refreshDataEffect',
          payload: { ...action },
        });
      }

      callback?.(res);
    } catch (e) {}
  };

const BrandModel: BrandModelType = {
  namespace: 'brand',
  state: {
    code: 0,
    type: '',
    message: 'success',
    items: [],
    total: 0,
    pageSize: 20,
    current: 1,
  },

  reducers: {
    BrandReducer(state, action) {
      const payload = action.payload || {};
      return {
        ...state,
        ...payload,
        items: payload.data?.items || [],
        total: payload.data?.total || 0,
        current: payload.data?.current || 1,
        pageSize: payload.data?.pageSize || 20,
      } as BrandState;
    },
  },

  effects: {
    *fetchBrandPageEffect(
      { payload: { pageSize, current, filter, sorter } }: any,
      { put, call }: any,
    ): Generator<any, void, any> {
      try {
        const res: any = yield call(getBrandPage, {
          pageSize,
          current,
          filter,
          sorter,
        });
        yield put({
          type: 'BrandReducer',
          payload: res,
        });
      } catch (e) {
        console.error('Fetch data failed:', e);
      }
    },

    // 通用刷新数据的 effect
    *refreshDataEffect(
      { payload: action }: any,
      { put, select }: any,
    ): Generator<any, void, any> {
      const current = yield select((state: any) => state.brand.current);
      const pageSize = yield select((state: any) => state.brand.pageSize);
      yield put({
        type: 'fetchBrandPageEffect',
        payload: {
          current,
          pageSize,
          filter: { ...action.filter },
          sorter: action.sorter || [],
        },
      });
    },

    // 简化的 effects
    addBrandEffect: createEffect(addBrand),
    editBrandEffect: createEffect(editBrand),
    removeBrandEffect: createEffect(removeBrand),
  },

  subscriptions: {
    setup() {},
  },
};

export default BrandModel;
